import { Box } from "@mui/material";
import { IconTooltip } from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import React, { useEffect, useState } from "react";
import { StyledThumbIcon } from "../Chat.styles";
import RefineModal from "./RefineModal";
import { useConfirm } from "features/home/ConfirmDialogProvider";
import { useIntl } from "react-intl";
import axios from "axios";
import { apiUrl } from "features/configure";
import { useOutletContext } from "react-router";
import { formatDate } from "features/helpers/utils";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";

export default function MessageRefine({ data, content, refreshPastMessages }) {
  const [thumb, setThumb] = useState("");
  const { formatMessage } = useIntl();
  const confirm = useConfirm();
  const [entityName] = useOutletContext();

  useEffect(() => {
    const { adminFeedback, userFeedback } = data;

    if (adminFeedback) {
      return setThumb(adminFeedback);
    }
    if (userFeedback) {
      return setThumb(userFeedback);
    }
  }, [data]);

  const dispatchSnackbar = useDispatchSnackbar();

  const handleThumbUp = async () => {
    try {
      if (thumb === "thumbDown") {
        confirm({
          title: formatMessage({
            id: "trainingArea.popup.confirmFeedback.title",
          }),
          content: formatMessage({
            id: "trainingArea.popup.confirmFeedback.desc",
          }),
          confirmText: formatMessage({ id: "global.btn.confirm" }),
          cancelText: formatMessage({ id: "global.btn.cancel" }),
          color: "secondary",
          cancelColor: "secondary",
        })
          .then(async () => {
            await axios.post(
              `${apiUrl}/api/trainingArea/${entityName}/messages`,
              {
                messageId: data._id,
                adminFeedback: "thumbUp",
              }
            );
            setThumb("thumbUp");
            refreshPastMessages();
          })
          .catch(() => {});
      } else {
        await axios.post(`${apiUrl}/api/trainingArea/${entityName}/messages`, {
          messageId: data._id,
          adminFeedback: "thumbUp",
        });
        setThumb("thumbUp");
        refreshPastMessages();
      }
    } catch (err) {
      dispatchSnackbar({ err });
    }
  };

  function handleThumbDown() {
    setOpenModal(true);
  }

  const [openModal, setOpenModal] = useState(false);

  const getTooltipText = (type) => {
    const {
      adminFeedback,
      adminFeedbackBy,
      adminFeedbackCreated,
      userFeedback,
      userFeedbackCreated,
    } = data;

    if (thumb === type) {
      if (adminFeedback === type) {
        return `Feedback from ${adminFeedbackBy?.name} on ${formatDate(
          adminFeedbackCreated
        )}`;
      }
      if (userFeedback === type) {
        return `Feedback from User on ${formatDate(userFeedbackCreated)}`;
      }
    }

    return formatMessage({
      id:
        type === "thumbUp"
          ? "trainingArea.feedback.good"
          : "trainingArea.feedback.bad",
    });
  };

  return (
    <>
      <Box className="item-flex" gap="0 6px" fontWeight={400}>
        {data.aiRespondsTo && (
          <>
            <IconTooltip
              icon={
                <StyledThumbIcon
                  className="meta-crm-icon-ic_thumb-up font-size-16"
                  active={thumb === "thumbUp"}
                  onClick={() => handleThumbUp()}
                />
              }
              content={getTooltipText("thumbUp")}
            />
            <IconTooltip
              icon={
                <StyledThumbIcon
                  className="meta-crm-icon-ic_thumb-down font-size-16"
                  active={thumb === "thumbDown"}
                  onClick={handleThumbDown}
                />
              }
              content={getTooltipText("thumbDown")}
            />
          </>
        )}

        {content}
      </Box>
      {openModal && (
        <RefineModal
          setThumb={setThumb}
          selectedMessage={data}
          onClose={() => setOpenModal(false)}
          refreshPastMessages={refreshPastMessages}
        />
      )}
    </>
  );
}
